module.exports = __webpack_public_path__ + "img/bg-accident-item-3.09759354.png";